import React from 'react';
import { motion } from 'framer-motion';
import styles from './Button.module.css';

/**
 * Button
 * variant: 'primary' | 'secondary' | 'dark' | 'ghost' | 'gradient' | 'outline'
 * size:    'sm' | 'md' | 'lg'
 * as:      component to render (e.g. Link, 'a', 'button'); defaults to 'button'
 * fullWidth: stretch to container
 * iconRight / iconLeft: ReactNode
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  as: Component = 'button',
  fullWidth = false,
  iconRight,
  iconLeft,
  className = '',
  ...rest
}) => {
  const classes = [
    styles.btn,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const MotionComponent = motion(Component);

  return (
    <MotionComponent
      whileHover={{ scale: 1.025, y: -1 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 400, damping: 22 }}
      className={classes}
      {...rest}
    >
      {iconLeft && <span className={styles.iconLeft}>{iconLeft}</span>}
      <span className={styles.label}>{children}</span>
      {iconRight && <span className={styles.iconRight}>{iconRight}</span>}
    </MotionComponent>
  );
};

export default Button;
